module.exports = __webpack_public_path__ + "img/welcome_bw.722e73f2.jpg";